import "./css/reset.css"
import "./css/colors.css"
import "./css/layout.css"
import "./css/plugins.css"
import "./css/fonts.css"
import "./css/typography.css"
import "./css/utils.css"
import "./css/icons.css"
import "./css/buttons.css"
import "./css/accordions.css"
import "./css/forms.css"
import "./css/header.css"
import "./css/nav.css"
import "./css/menu-icon.css"
import "./css/footer.css"
import "./css/teaser.css"
import "./css/breadcrumbs.css"
import "./css/lead.css"
import "./css/pagination.css"
import "./css/filter.css"
import "./css/tools.css"
import "./css/contact.css"
import "./css/bentos.css"
import "./css/masonry.css"
import "./css/search.css"
import "./css/cursor.css"
import "./css/gallery.css"

import "./css/cookiecontrol.css"

import "./css/admin.css"
import "./css/variables.css"
import "./css/sexed_es.css"
import "./css/snippets.css"

import "./css/landingpages/colors.css"
import "./css/landingpages/general.css"
import "./css/landingpages/tools.css"
import "./css/landingpages/header.css"
import "./css/landingpages/boxes.css"
import "./css/landingpages/footer.css"

import { initCursorBoembel } from "./js/components/cursor"
import { initIntersectionAnimate } from "./js/components/intersection-animate"
import { initMultistepFormFocus } from "./js/components/multistep-form"
import { initNav } from "./js/components/nav"
import { initNewsletterForm } from "./js/components/newsletter-form"
import { initOfferFold } from "./js/components/offer-fold"
import { initTools } from "./js/components/tools"
import { initDetails } from "./js/utils/details"
import { onReady, onReadyIfPresent } from "./js/utils/dom"

// Cheap, dependency-free enhancements which run on (almost) every page.
onReady(initNav)
onReady(initCursorBoembel)
onReady(initDetails)
onReady(initIntersectionAnimate, true)
onReady(initOfferFold)
onReady(initTools)
onReady(initMultistepFormFocus)
onReady(initNewsletterForm)

// Everything below drags in React, mapbox-gl, react-select or the chat widget
// -- together several hundred kilobytes which only a handful of pages need.
// Loading them behind a dynamic import keeps them out of main.js, and the
// selector check means the request only happens on pages using the feature.
// The component's own CSS is imported by the component, so it travels with it.
onReadyIfPresent(".masonry", async () =>
  (await import("./js/components/masonry")).initMasonry(),
)
onReadyIfPresent("#map", async () =>
  (await import("./js/components/mapLoader")).initMap(),
)
onReadyIfPresent(
  "[data-timeslot-widget-container]",
  async () =>
    (await import("./js/components/timeslot-selector")).initTimeslotSelector(),
  true,
)
onReadyIfPresent(
  ".gallery-container",
  async () => (await import("./js/components/gallery")).initGallery(),
  true,
)
onReadyIfPresent(
  "#my-drink-control-section",
  async () => (await import("./js/components/drinkControl")).initDrinkControl(),
  true,
)
onReadyIfPresent(
  "#self-check-section",
  async () => (await import("./js/components/selfCheck")).initSelfCheck(),
  true,
)
onReadyIfPresent(
  ".filelist",
  async () => (await import("./js/components/filelists")).initFileLists(),
  true,
)

// The chat widget key is injected by a CMS snippet which may run before or
// after this bundle; keep both orderings working, but only fetch the messenger
// once a key actually shows up.
onReady(() => {
  const initChat = async (secret) =>
    (await import("./js/components/chat")).initChat(secret)

  if (window._initChat) initChat(window._initChat)
  else window._initChat = initChat
})

const cl = document.documentElement.classList
cl.remove("no-js")
cl.add("js")
